import { Button, Form, Input, Modal, message } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const FORM_ID = 'edit-hierarchy-entity-form';

const EditHierarchyEntityPopup: FC<any> = ({
	onCancel,
	onSuccess,
	onSave,
	entity,
	entityName,
	requiredParams,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			setSaving(true);
			onSave({
				...entity,
				...requiredParams,
				name: values.name,
			})
				.then(() => onSuccess())
				.catch((err) => message.error(err))
				.finally(() => setSaving(false));
		},
		[onSave, entity, requiredParams, onSuccess]
	);

	return (
		<Modal
			visible={true}
			title={`Edit ${entityName}`}
			onCancel={onCancel}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_ID}
					loading={saving}
				>
					Save
				</Button>,
			]}
			closable={true}
		>
			<Form id={FORM_ID} layout="vertical" requiredMark={false} onFinish={handleSubmit}>
				<Form.Item
					name="name"
					label="Name"
					initialValue={nullSafeGet('name', entity)}
					rules={[{ required: true, message: `Please enter a name for the ${entityName}!` }]}
				>
					<Input type="text" placeholder={`Enter Name of this ${entityName}`} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditHierarchyEntityPopup;
